import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, TitleStrategy, withComponentInputBinding, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { languageInitializer } from '../shared/core/application/language-utils';
import { acceptLanguageInterceptor } from '../shared/core/application/accept-language.interceptor';
import { AppTitleStrategy } from './app-title-strategy';
import { IconsService } from '../shared/icons/icons.service';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { withCredentialsInterceptor } from '../auth/credentials-interceptor';
import { RuntimeConfigService } from './runtime-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideHttpClient(
      withFetch(),
      withInterceptors([
        withCredentialsInterceptor,
        acceptLanguageInterceptor,
      ]),
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: "./assets/i18n/",
        suffix: `.json?cb=${(new Date().getTime() / 1000 / 60).toFixed(0)}`,
      }),
      fallbackLang: "en",
    }),
    provideAppInitializer(() => {
      return languageInitializer();
    }),
    provideAppInitializer(() => {
      const iconsService = inject(IconsService);
      return iconsService.registerAppIcons();
    }),
    provideAppInitializer(() => {
      const runtimeConfigService = inject(RuntimeConfigService);
      return runtimeConfigService.load();
    }),
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'pl-PL' }
  ]
};
